Invitation = require 'models/invitation'

module.exports = class OrganizationInvitation extends Invitation
  typeName: 'OrganizationInvitation'



// WEBPACK FOOTER //
// ./app/scripts/models/organization-invitation.coffee